import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'inline-block',
    margin: '1em 1em 1em 0'
  }
});
